import * as renderItems from './renderItems';
import { VxeUI } from 'vxe-design';

const camelCase2Hyphen = str => str.replace(/([A-Z])/g, '-$1').toLowerCase();

Object.keys(renderItems).forEach(k => {
    const { name = camelCase2Hyphen(k) } = renderItems[k];
    VxeUI.renderer.add(name, renderItems[k]);
});
